module.exports = __webpack_public_path__ + "static/media/facebook.cf83b05b.svg";